import React, { useState } from "react";
import { DataTable, } from "@sscs/ui";
import PolicyRule from "../policyRule/PolicyRule";
import styles from "./policyTable.module.scss";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "id",
        label: "ID",
        sortProperty: "id",
        sortId: "issues-sort-id",
        width: "100px",
    },
    { id: "description", label: "Description", width: "100%" },
    { id: "enabled", label: "Enabled", width: "90px" },
    {
        id: "priority",
        label: "Priority",
        sortProperty: "grade",
        sortId: "issues-sort-priority",
        startReverse: true,
        width: "110px",
    },
    {
        id: "cicd",
        label: "CI/CD",
        sortProperty: "status",
        sortId: "issues-sort-ci-cd",
        width: "140px",
    },
];
const PolicyTable = ({ policies, sortBy, pagination, filters, onSortChange, }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    return (React.createElement(DataTable, { chrome: "plain", size: "large", tableClassName: styles.table, columns: COLUMNS, sort: sortBy, onSortChange: onSortChange, empty: { subject: "issues", filters }, pagination: pagination }, policies.map((policy, index) => (React.createElement(PolicyRule, { id: `issues-expand-row-${index}`, key: policy.id, policy: policy, focused: index === activeIndex, onClick: () => setActiveIndex(index) })))));
};
export default PolicyTable;
//# sourceMappingURL=PolicyTable.js.map